export const CLEAR_CACHE = 'CLEAR_CACHE';
export const CLEAR_REQUEST_CACHE = 'CLEAR_REQUEST_CACHE';
export const CLEAR_FAVORITES_CACHE = 'CLEAR_FAVORITES_CACHE';

export const LENGTH_CHANGED = 'LENGTH_CHANGED';
export const QTY_CHANGED = 'QTY_CHANGED';

export const FABRIC_SELECTED = 'FABRIC_SELECTED';
export const SEWPAT_SELECTED = 'SEWPAT_SELECTED';
export const SEWPAT_SETTED = 'SEWPAT_SETTED';
export const DESIGN_SELECTED = 'DESIGN_SELECTED';
export const FASHION_SIZE_SELECTED = 'FASHION_SIZE_SELECTED';
export const SEWPAT_OPTIONS_SELECTED = 'SEWPAT_OPTIONS_SELECTED';
export const PRODUCT_SELECTED = 'PRODUCT_SELECTED';

export const CART_RESETTED = 'CART_RESETTED';
export const LOCALE_CHANGED = 'LOCALE_CHANGED';
export const LOCALE_SETTED_FROM_URI = 'LOCALE_SETTED_FROM_URI';

export const PATTERN_SELECTED = 'PATTERN_SELECTED';

export const NAVIGATED_TO_TOPCATEGORIES = 'NAVIGATED_TO_TOPCATEGORIES';
export const NAVIGATED_TO_SUBCATEGORIES = 'NAVIGATED_TO_SUBCATEGORIES';
export const CATEGORIES_REQUESTED = 'CATEGORIES_REQUESTED';
export const CATEGORIES_RECEIVED = 'CATEGORIES_RECEIVED';
export const CATEGORIES_REQUEST_FAILED = 'CATEGORIES_REQUEST_FAILED';
export const CATEGORIES_DID_INVALIDATE = 'CATEGORIES_DID_INVALIDATE';

export const NAVIGATED_TO_CATEGORIE_PATTERNS_GALLERY = 'NAVIGATED_TO_CATEGORIE_PATTERNS_GALLERY';
export const NAVIGATED_TO_SINGLE_PATTERN_VIEW = 'NAVIGATED_TO_SINGLE_PATTERN_VIEW';
export const NAVIGATED_TO_SIMILIAR_PATTERNS_VIEW = 'NAVIGATED_TO_SIMILIAR_PATTERNS_VIEW';
export const NAVIGATED_TO_DEFAULT_NEWEST_PATTERNGALLERY = 'NAVIGATED_TO_DEFAULT_NEWEST_PATTERNGALLERY';
export const NAVIGATED_TO_NEWEST_PATTERNGALLERY = 'NAVIGATED_TO_NEWEST_PATTERNGALLERY';

export const PATTERNS_REQUESTED = 'PATTERNS_REQUESTED';
export const PATTERNS_RECEIVED = 'PATTERNS_RECEIVED';
export const PATTERNS_REQUEST_FAILED = 'PATTERNS_REQUEST_FAILED';
export const PATTERNS_DID_INVALIDATE = 'PATTERNS_DID_INVALIDATE';

export const NAVIGATED_TO_DESIGNEROVERVIEW = 'NAVIGATED_TO_DESIGNEROVERVIEW';
export const NAVIGATED_TO_PATTERNS_FROM_DESIGNER = 'NAVIGATED_TO_PATTERNS_FROM_DESIGNER';
export const DESIGNERINFO_REQUESTED = 'DESIGNERINFO_REQUESTED';
export const DESIGNERINFO_RECEIVED = 'DESIGNERINFO_RECEIVED';
export const DESIGNERINFO_REQUEST_FAILED = 'DESIGNERINFO_REQUEST_FAILED';
export const DESIGNERINFO_DID_INVALIDATE = 'DESIGNERINFO_DID_INVALIDATE';

export const RECOLORING_REQUESTED = 'RECOLORING_REQUESTED';
export const RECOLORING_RECEIVED = 'RECOLORING_RECEIVED';
export const RECOLORING_REQUEST_FAILED = 'RECOLORING_REQUEST_FAILED';

export const COLORS_REQUESTED = 'COLORS_REQUESTED';
export const COLORS_RECEIVED = 'COLORS_RECEIVED';
export const COLORS_REQUEST_FAILED = 'COLORS_REQUEST_FAILED';
export const COLORS_DID_INVALIDATE = 'COLORS_DID_INVALIDATE';

export const ERROR_MESSAGE_RESETTED = 'ERROR_MESSAGE_RESETTED';

export const QUERY_MODIFIED = 'QUERY_MODIFIED';
export const PATTERN_QUERY_MODIFIED = 'PATTERN_QUERY_MODIFIED';
export const QUERY_RESETTED = 'QUERY_RESETTED';

export const SET_CATEGORY_GALLERY_PAGE = 'SET_CATEGORY_GALLERY_PAGE';
export const SET_FAVORITES_GALLERY_PAGE = 'SET_FAVORITES_GALLERY_PAGE';
export const SET_SEARCH_RESULT_PAGE = 'SET_SEARCH_RESULT_PAGE';

export const UI_SWATCH_SELECTED = 'UI_SWATCH_SELECTED';
export const UI_PICKER_SHOWN = 'UI_PICKER_SHOWN';
export const UI_PICKER_HIDED = 'UI_PICKER_HIDED';
export const UI_COLOR_INPUT_FOCUS_TOGGLED = 'UI_COLOR_INPUT_FOCUS_TOGGLED';
export const ACTIVE_BREAKPOINT_CHANGED = 'ACTIVE BREAKPOINT CHANGED';
export const SHOW_ALL_SWATCHES_SELECTED = 'SHOW_ALL_SWATCHES_SELECTED';
export const UI_TOGGLE_HEADER_MENU = 'UI_TOGGLE_HEADER_MENU';
export const UI_TOGGLE_FIGURINE_PREVIEW = 'UI_TOGGLE_FIGURINE_PREVIEW';

export const NAVIGATED_TO_SEARCHGALLERY = 'NAVIGATED_TO_SEARCHGALLERY';
export const NAVIGATED_TO_COLOR_SEARCHGALLERY = 'NAVIGATED_TO_COLOR_SEARCHGALLERY';
export const SITESEARCH_FOCUSED = 'SITESEARCH FOCUSED';
export const SITESEARCH_BLURRED = 'SITESEARCH BLURRED';
export const SITESEARCH_CHANGED = 'SITESEARCH VALUE CHANGED';

export const COLORPICKER_COLOR_CHANGED = 'COLORPICKER_COLOR_CHANGED';
export const SLIDER_HUE_CHANGED = 'SLIDER_HUE_CHANGED';
export const SLIDER_SATURATION_CHANGED = 'SLIDER_SATURATION_CHANGED';
export const SLIDER_LIGHTNESS_CHANGED = 'SLIDER_LIGHTNESS_CHANGED';
export const SLIDER_RECOLOR = 'SLIDER_RECOLOR';
export const COLOR_SLIDER_RESETTED = 'COLOR_SLIDER_RESETTED';

export const RECOLOR = 'RECOLOR';
export const COLORS_RESETTED = 'COLORS_RESETTED';

export const COLOR_CHANGED = 'COLOR_CHANGED';

export const PD_FETCH_COLORS = 'PATTERNDESIGN_API_FETCH_COLORS';
export const PD_FETCH_CAT = 'PATTERNDESIGN_API_FETCH_CATEGORIES';
export const PD_SEARCH_PATTERNS = 'PATTERNDESIGN_API_SEARCH_PATTERNS';
export const PD_FETCH_PATTERNS = 'PATTERNDESIGN_API_FETCH_PATTERNS';
export const PD_FETCH_DESIGNER = 'PATTERNDESIGN_API_FETCH_DESIGNER';

export const PD_RECOLOR = 'PATTERNDESIGN_API_RECOLOR_PATTERN';

export const ADDED_TO_FAVORITES = 'ADDED_TO_FAVORITES';
export const REMOVED_FROM_FAVORITES = 'REMOVED_FROM_FAVORITES';

export const NAVIGATED_TO_HOME = 'NAVIGATED_TO_HOME';
export const NAVIGATED_TO_ABOUT = 'NAVIGATED_TO_ABOUT';
export const NAVIGATED_TO_TOS = 'NAVIGATED_TO_TOS';
export const NAVIGATED_TO_PRIVACY = 'NAVIGATED_TO_PRIVACY';
export const NAVIGATED_TO_CONTACT = 'NAVIGATED_TO_CONTACT';
export const NAVIGATED_TO_IMPRINT = 'NAVIGATED_TO_IMPRINT';
export const NAVIGATED_TO_SETTINGS = 'NAVIGATED_TO_SETTINGS';
export const NAVIGATED_TO_FAQ_FABRICS = 'NAVIGATED_TO_FAQ_FABRICS';
export const NAVIGATED_TO_FAQ_SEWPATS = 'NAVIGATED_TO_FAQ_SEWPATS';
export const NAVIGATED_TO_FAQ_RECOLORING = 'NAVIGATED_TO_FAQ_RECOLORING';
export const NAVIGATED_TO_FAQ_SHIPPING = 'NAVIGATED_TO_FAQ_SHIPPING';
export const NAVIGATED_TO_HASHTAG = 'NAVIGATED_TO_HASHTAG';

export const NAVIGATED_TO_SUBCATEGORY_PANE = 'NAVIGATED_TO_SUBCATEGORY_PANE';

export const NAVIGATED_TO_DESIGNERGALLERY = 'NAVIGATED_TO_DESIGNERGALLERY';

export const NAVIGATED_TO_NEWSLETTER_FORM = 'NAVIGATED_TO_NEWSLETTER_FORM';
export const NAVIGATED_TO_NEWSLETTER_SUBSCRIBED = 'NAVIGATED_TO_NEWSLETTER_SUBSCRIBED';
export const NAVIGATED_TO_NEWSLETTER_CONFIRMED = 'NAVIGATED_TO_NEWSLETTER_CONFIRMED';

export const NAVIGATED_TO_CHECKOUT_COMPLETED = 'NAVIGATED_TO_CHECKOUT_COMPLETED';

export const NAVIGATED_TO_COLORSWATCHES_CART_FORM = 'NAVIGATED_TO_COLORSWATCHES_CART_FORM';

export const NAVIGATED_TO_LOVED_PATTERNS = 'NAVIGATED_TO_LOVED_PATTERNS';

export const NAVIGATED_TO_SEWPAT_VIEW = 'NAVIGATED_TO_SEWPAT_VIEW';
export const NAVIGATED_TO_SEWPAT_GALLERY = 'NAVIGATED_TO_SEWPAT_GALLERY';
export const NAVIGATED_TO_SEWPAT_PATTERN_GALLERY = 'NAVIGATED_TO_SEWPAT_PATTERN_GALLERY';
export const NAVIGATED_TO_SINGLE_SEWPAT_PATTERN_GALLERY = 'NAVIGATED_TO_SINGLE_SEWPAT_PATTERN_GALLERY';

export const NAVIGATED_TO_SEWPAT_SAME_LEVEL = 'NAVIGATED_TO_SEWPAT_SAME_LEVEL';
export const NAVIGATED_TO_SEWPAT_CATEGORIE = 'NAVIGATED_TO_SEWPAT_CATEGORIE';

export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const DISMISS_SNACKBAR = 'DISMISS_SNACKBAR';

export const SHOW_RECOLORING_LOADER = 'SHOW_RECOLORING_LOADER';
export const HIDE_RECOLORING_LOADER = 'HIDE_RECOLORING_LOADER';

export const LAZY_LOAD_INTERSECTION_TRIGGERED = 'LAZY_LOAD_INTERSECTION_TRIGGERED';

export const SHARABLE_PRODUCT_IMAGE_SETTED = 'SHARABLE_PRODUCT_IMAGE_SETTED';



// WEBPACK FOOTER //
// ./src/actions/actionTypes.js